import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
      staggerChildren: 0.1
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function PageTransition({
  children,
  className = ''
}: PageTransitionProps) {
  return <motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} className={`w-full ${className}`} data-id="element-1055">
      {children}
    </motion.div>;
}